import { useNavigate } from 'react-router-dom';

// A clickable summary card for the dashboard — shows a big number,
// a label, and an optional secondary line, navigating to the relevant
// screen when clicked.
function SummaryCard({ icon: Icon, iconColor, iconBg, label, value, subtext, to }) {
  const navigate = useNavigate();

  return (
    <div onClick={() => navigate(to)} style={styles.card}>
      <div style={{ ...styles.iconCircle, backgroundColor: iconBg }}>
        <Icon size={22} color={iconColor} />
      </div>
      <div style={styles.value}>{value}</div>
      <div style={styles.label}>{label}</div>
      {subtext && <div style={styles.subtext}>{subtext}</div>}
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: 'white',
    borderRadius: 14,
    padding: 20,
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    cursor: 'pointer',
    transition: 'box-shadow 0.15s ease',
  },
  iconCircle: {
    width: 42,
    height: 42,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 14,
  },
  value: {
    fontSize: 26,
    fontWeight: 800,
    color: '#111827',
    marginBottom: 2,
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: '#6b7280',
  },
  subtext: {
    fontSize: 12,
    color: '#9ca3af',
    marginTop: 6,
  },
};

export default SummaryCard;